import { useState, VFC } from 'react'
import { Link } from 'src/elements/Link'
import { lightorange, orange } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { leftArrow } from 'src/styles/mixins'
import styled, { css } from 'styled-components'
import { DropDownMenuItemProps, DropDownMenuProps } from './types'

export * from './items'

export const DropDownMenu: VFC<DropDownMenuProps> = ({ title, items }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  return (
    <DropDownMenuDiv>
      <DropDownMenuButton
        onClick={() => setMenuOpen(!isMenuOpen)}
        isOpen={isMenuOpen}
      >
        {title}
      </DropDownMenuButton>
      <DropDownMenuItems isOpen={isMenuOpen}>
        {items.map(({ href, label }) => (
          <DropDownMenuItem key={label} href={href} label={label} />
        ))}
      </DropDownMenuItems>
    </DropDownMenuDiv>
  )
}

export const MenuLink: VFC<DropDownMenuItemProps> = ({ href, label }) => (
  <DropDownMenuDiv>
    <DropDownMenuLink href={href}>{label}</DropDownMenuLink>
  </DropDownMenuDiv>
)

const DropDownMenuItem: VFC<DropDownMenuItemProps> = ({ href, label }) => (
  <DropDownMenuListItem>
    <Link href={href}>{label}</Link>
  </DropDownMenuListItem>
)

const DropDownMenuDiv = styled.div`
  font-size: 14px;
  font-weight: ${fontWeightBold};
  position: relative;
`
const dropDownMenuButtonStyle = css`
  position: relative;
  :hover {
    color: ${orange};
  }

  ::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    margin-left: 8px;
    width: 8px;
    height: 8px;
    border: solid 2px;
    border-bottom: none;
    border-left: none;
    transform: rotate(45deg);

    transition: 0.2s, transform 0.5s;
  }
`
const DropDownMenuLink = styled(Link)`
  ${dropDownMenuButtonStyle};
`
const DropDownMenuButton = styled.button<{ isOpen: boolean }>`
  ${dropDownMenuButtonStyle};
  ${({ isOpen }) =>
    isOpen &&
    css`
      ::after {
        top: -20%;
        transform: rotate(135deg);
      }
    `}
`

const DropDownMenuItems = styled.ul<{ isOpen: boolean }>`
  position: absolute;
  top: 30px;
  background-color: ${orange};

  clip-path: inset(0 0 100%);
  transition: clip-path 0.2s ease-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      clip-path: inset(0);
    `}
`

const DropDownMenuListItem = styled.li`
  position: relative;
  width: 100%;
  border-top: 1px solid;
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  white-space: nowrap;
  a {
    display: block;
    padding: 10px 40px 10px 20px;
    :hover {
      background-color: ${lightorange};
    }
  }

  ${leftArrow};
`
